// extracted by mini-css-extract-plugin
export var quantityInput = "_jx-0";